import { EVENT_CALENDAR_CLEAN, } from "../interface/iEventCalendar";
import { EVENT_CALENDAR, EVENT_CALENDAR_ERROR, EVENT_CALENDAR_HIDE_ERROR, EVENT_CALENDAR_START_LOADER, EVENT_CALENDAR_STOP_LOADER, } from "../interface/iEventCalendar";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const eventCalendarReducer = (state = initState, action) => {
    switch (action.type) {
        case EVENT_CALENDAR: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case EVENT_CALENDAR_CLEAN: {
            return Object.assign(Object.assign({}, state), { data: initState.data });
        }
        case EVENT_CALENDAR_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EVENT_CALENDAR_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EVENT_CALENDAR_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EVENT_CALENDAR_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default eventCalendarReducer;
